<template>
  <div class="page">
    <Loading v-if="loading" isFull isCenter isTall />
    <Map v-else :locations="restaurants"/>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { getResList } from "../composables/getResDetails";

import { Loading } from "@/revamp/components";
import { Map } from "@/components";

const loading = ref(true);
const restaurants  = ref([]) 

onMounted(async () => {
  init();
});

async function init() {
  restaurants.value = (await getResList(false)).filter((res) => res.coordinates);
  loading.value = false;
}

</script>

<style>
.page {
  height: 100vh;
  width: 100vw;
  position: relative;
}
</style>